// ImagePicker.js
import React, { useCallback } from 'react';
import { useDropzone } from 'react-dropzone';

const ImagePicker = ({ onImageSelect,handleFileChange,setImage }) => {
  const onDrop = useCallback((acceptedFiles) => {
    // Do something with the selected image
    // const selectedImage = acceptedFiles[0];
    // handleFileChange(selectedImage);
    // onImageSelect(acceptedFiles);
    if (acceptedFiles[0] && acceptedFiles.length > 0) {

        const reader = new FileReader();
        reader.onload = () => {
          setImage(reader.result);
        };
        reader.readAsDataURL(acceptedFiles[0]);
    }
  }, [setImage]);

  const { getRootProps, getInputProps } = useDropzone({
    accept: 'image/*',
    onDrop,
  });
//tyu
  return (
    <>
     <div {...getRootProps()} style={dropzoneStyles}>
      <input {...getInputProps()} />
      <p>Drag 'n' drop an image here, or click to select one</p>
    </div>
    </>
   
  );
};

const dropzoneStyles = {
  border: '2px dashed #cccccc',
  borderRadius: '4px',
  padding: '20px',
  textAlign: 'center',
  cursor: 'pointer',
};

export default ImagePicker;
